import { useId } from 'react';

/**
 * Полоса прогресса замера скорости (0–100%) с диагональными полосами и подписью этапа.
 */
export function AdminSpeedMeasureProgressBar({ percent = 0, label = '' }) {
  const rawId = useId().replace(/:/g, '');
  const gradId = `spg_${rawId}`;
  const patId = `sps_${rawId}`;
  const clipId = `spc_${rawId}`;
  const w = 300;
  const h = 16;
  const r = 8;
  const p = Math.min(100, Math.max(0, Number(percent) || 0));
  const fillW = (p / 100) * w;

  return (
    <div className="admin-speed-measure-progress" aria-busy="true" aria-live="polite">
      <div className="admin-speed-measure-progress__label">{label}</div>
      <div className="admin-speed-measure-progress__track-wrap">
        <svg
          className="admin-speed-measure-progress__svg"
          width="100%"
          height="20"
          viewBox={`0 0 ${w} 20`}
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <defs>
            <pattern id={patId} x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
              <g>
                <animateTransform
                  attributeName="transform"
                  type="translate"
                  from="0 0"
                  to="40 0"
                  dur="1s"
                  repeatCount="indefinite"
                />
                <path
                  d="M-10,30 l40,-40 M0,40 l40,-40 M30,50 l40,-40"
                  stroke="rgba(255,255,255,0.35)"
                  strokeWidth="15"
                  fill="none"
                />
              </g>
            </pattern>
            <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#4facfe" />
              <stop offset="100%" stopColor="#00f2fe" />
            </linearGradient>
            <clipPath id={clipId}>
              <rect x="0" y="0" width={fillW} height={h} rx={r} ry={r} />
            </clipPath>
          </defs>
          <rect x="0" y="0" width={w} height={h} rx={r} ry={r} fill="#e0e0e0" />
          <g clipPath={`url(#${clipId})`}>
            <rect x="0" y="0" width={w} height={h} rx={r} ry={r} fill={`url(#${gradId})`} />
            <rect x="0" y="0" width={w} height={h} rx={r} ry={r} fill={`url(#${patId})`} />
          </g>
        </svg>
        <span className="admin-speed-measure-progress__pct">{p}%</span>
      </div>
    </div>
  );
}
